import { Action, IOWidget, mk_widget, mk_pair } from 'widgets-for-react'
import React from 'react'

import { CMSState } from '../../../../cms/blocks/types.gen'
import { getClassName } from '../../../../cms/blocks/utils.gen'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { Form } from '../../../../form'
import { FormState } from '../../../../form/types'
import { PublicSiteState } from '../../../../public_site.main.mod'

export type FormBlockProps = {
  block_index: number
  form_id: string
  state: FormState
}

export type FormBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  content_classname: string
}>

export function FormBlock<CustomBlockData, extra_images>(
  props: FormBlockProps,
  options?: { key?: string }
  ): (s:CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<CustomBlockData,extra_images, PublicSite_CustomPageData>>> {
    return (s: CMSState<CustomBlockData,extra_images, PublicSite_CustomPageData>) => (public_state:PublicSiteState) =>
    mk_widget({
      run: set_state => (
        <section
          className="block block--form"
          key={options && options.key ? options.key : 'iframe-block'}
        >
          <div className="block__inner container--xs grid--block">
            <div className="block__content">
              {
                Form(props.state).run(future_state => {
                  let new_state= future_state(props.state)

                  if (new_state.form_submission_logic.kind == 'loaded')
                    if (!window.dataLayer.find(layer => layer.action == "Form"))
                      window.dataLayer.push({
                        event: "event.fccorporate", category: "Contact", action: "Form", label: window.location.pathname
                      });

                  set_state(s => {
        
                    let currentBlock = s.blocks.get(props.block_index) as any
                    if (currentBlock.kind === 'formBlock') {
                      currentBlock = {
                        ...currentBlock,
                        value: mk_pair(
                          { ...currentBlock.value.fst, state: {...new_state, route_state:"none"} },
                          currentBlock.value.snd
                        )
                      }
                    }
        
                    
                    return { ...s, blocks: s.blocks.set(props.block_index, currentBlock) }
                  })
                })
              }
            </div>
          </div>
        </section>
      )
    })
}
